import { usePageViewAnalytics, PRODUCT_AREA } from '@leagueplatform/analytics';
import { ANALYTICS_SCREEN_NAMES } from '@telus-alberta-health-web/shared-module';
import { useIntl } from '@leagueplatform/locales';
import { Masonry } from '@leagueplatform/masonry';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { MASONRY, SECONDARY_CONTENT_MAX_WIDTH } from 'common/constants';
import { PageContentWrapper } from 'components/page-content-wrapper.component';

export const PrivacyPolicyInAppPage = () => {
  usePageViewAnalytics({
    screen_name: ANALYTICS_SCREEN_NAMES.PRIVACY_NOTICE,
    product_area: PRODUCT_AREA.SETTINGS,
  });

  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_PRIVACY_POLICY' }));
  return (
    <PageContentWrapper
      css={{
        maxWidth: SECONDARY_CONTENT_MAX_WIDTH,
        marginBlockStart: '$three',
      }}
    >
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_PRIVACY_POLICY_IN_APP} />
    </PageContentWrapper>
  );
};
